import { Route, Routes } from 'react-router-dom';

import { CreatePlanForm } from './components/CreatePlanForm';
import { Plans } from './Plans';

const PlansView = () => {
  return (
    <Routes>
      <Route path="/" element={<Plans />} />
      <Route path="/form" element={<CreatePlanForm />} />
      <Route path="/form/:planId" element={<CreatePlanForm edit={true} />} />
    </Routes>
  );
};

export default PlansView;
